import React from 'react';
import { Box, Typography } from '@mui/material';
import { TextInput, PhoneInput, AddressInput } from 'framework/form';
import { AdditionalContactListInput } from 'domain/shared/contact';
import ContactFormSection from './ContactFormSection';

const ContactInfoForm: React.FC = () => {
  return (
    <Box>
      <ContactFormSection title="Personal contact">
        <PhoneInput source="extendedInformation.personalPhoneNumber" label="Personal phone number" />
        <TextInput source="extendedInformation.personalEmail" label="Personal email address" />
        <PhoneInput source="extendedInformation.otherPhoneNumber" label="Other phone number" />
        <AdditionalContactListInput
          source="extendedInformation.additionalContactInfo"
          label="Other contact information"
        />
      </ContactFormSection>

      <ContactFormSection title="Address information">
        <Typography variant="subtitle1">Registration address</Typography>
        <AddressInput source="extendedInformation.registrationAddress" label="Registration address" />
        <Typography variant="subtitle1">Current location address</Typography>
        <AddressInput source="extendedInformation.homeAddress" label="Current location address" />
      </ContactFormSection>
    </Box>
  );
};

export default ContactInfoForm;
